import React from 'react';
import { ExtratoCD } from '@entidades';

interface IProps {
  contribuicoes: Array<ExtratoCD>;
}

export const ExtratoCotas: React.FC<IProps> = ({
  contribuicoes
}) => {

  function ToMoney(Valor: number | undefined | null, FractionDigits = -1) {
    var options: any = {
      minimumFractionDigits: 2
    }
    if (FractionDigits > -1) {
      options = {
        minimumFractionDigits: FractionDigits,
        maximumFractionDigits: FractionDigits
      }
    }
    if (Valor === null || Valor === undefined)
      return 0;
    return (
      Valor.toLocaleString('pt-br', options)
    );
  }

  function renderContribuicoes() {
    const contribs = contribuicoes.map((contribuicao: ExtratoCD, index: number) => {
      return (
        <tr className={"text-right"} key={index}>
          <td className={"text-center"}>
            {contribuicao.MES_REF + "/" + contribuicao.ANO_REF}
          </td>
          <td >
            {ToMoney((contribuicao.QTD_COTA_RP_PARTICIPANTE), 8)}
          </td>
          <td>
            {ToMoney(contribuicao.QTD_COTA_RP_EMPRESA, 8)}
          </td>
          <td>
            {ToMoney((contribuicao.VOLUNTARIA_PART_COTA), 8)}
          </td>
          <td >
            {ToMoney(contribuicao.PORTABILIDADE_COTA, 8)}
          </td>
          <td>
            {ToMoney(contribuicao.TOTAL_CONTRIB_COTAS, 8)}
          </td>
          <td >
            {ToMoney(contribuicao.SALDO_COTA, 8)}
          </td>
          <td>
            {ToMoney(contribuicao.RENTABILIDADE, 4)}%
          </td>
        </tr>
      );
    });
    return (
      <div className={"table-responsive"}>
        <table className={"table table-striped table-bordered table-sm"}>
          <thead>
            <tr className={"text-center"}>
              <th className={"align-middle"}>
                {"Ref."}
              </th>
              <th className={"align-middle"}>
                {"Básica Part."}
              </th>
              <th className={"align-middle"}>
                {"Básica Patroc."}
              </th>
              <th className={"align-middle"}>
                {"Voluntária"}
              </th>
              <th className={"align-middle"}>
                {"Portab."}
              </th>
              <th className={"align-middle"}>
                {"Contrib Total"}
              </th>
              <th className={"align-middle"}>
                {"Saldo Final"}
              </th>
              <th className={"align-middle"}>
                {"Rentab em %"}
              </th>
            </tr>
          </thead>

          <tbody>
            {contribs}
          </tbody>
        </table>
      </div>
    );
  }

  return renderContribuicoes();
}